import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql, compose, gql } from 'react-apollo';
import { injectIntl } from 'react-intl';
//Components
import HomeBannerContent from './HomeBannerContent';
import SliderAnimation from '../SliderAnimation';
import Layout4 from '../Layout4/Layout4';
import AIBanner from '../AIBanner';

import { photosShow } from '../../../helpers/photosShow';
import { homebanneruploadDir } from '../../../config';
import { toWebp } from '../../../helpers/imageHelper';

// Helper to get localized value from key-value data
const getLocalizedValue = (item, locale) => {
  if (!item) return '';
  const code = locale ? locale.substring(0, 2).toLowerCase() : 'es';
  if (code === 'es') return item.value || '';
  const localizedField = `value_${code}`;
  return item[localizedField] || item.value || '';
};

class HomeBanner extends React.Component {

  static propTypes = {
    getImageBannerData: PropTypes.shape({
      loading: PropTypes.bool,
      getImageBanner: PropTypes.object
    }),
  };

  static defaultProps = {
    getImageBannerData: {
      loading: true
    },
  }

  render() {
    const { layoutType, wholeData, getBannerData, locale } = this.props;
    let infoCollection = {}, title, content, bannerImage, path;
    path = photosShow(homebanneruploadDir);
    if (wholeData) {
      // Get localized title and content
      const code = locale ? locale.substring(0, 2).toLowerCase() : 'es';
      if (code === 'es') {
        title = wholeData.title;
        content = wholeData.content;
      } else {
        title = wholeData[`title_${code}`] || wholeData.title;
        content = wholeData[`content_${code}`] || wholeData.content;
      }
      if (wholeData.getFindYouCar && Array.isArray(wholeData.getFindYouCar)) {
        wholeData.getFindYouCar.map((item, key) => {
          infoCollection[item.name] = getLocalizedValue(item, locale);
        });
      }
      if (wholeData.getBanner && wholeData.getBanner.image) {
        bannerImage = path + toWebp(wholeData.getBanner.image);
      }
    }
    return (
      <>
        {layoutType && (layoutType == 1 || layoutType == 3) && <SliderAnimation layoutType={layoutType} data={getBannerData} />}
        {
          layoutType && layoutType == 4 &&
          <Layout4 title={title} content={content} bannerImage={bannerImage} />
        }
        {
          layoutType && layoutType == 5 &&
          <AIBanner title={title} content={content} bannerImage={bannerImage} />
        }
        <HomeBannerContent layoutType={layoutType} wholeData={wholeData} infoCollection={infoCollection} getBannerData={getBannerData} />
      </>
    )
  }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

export default compose(
  injectIntl,
  connect(mapState),
  graphql(gql`
        query getBanner{
          getBanner {
            id
            title
            title_en
            title_fr
            title_it
            title_pt
            content
            content_en
            content_fr
            content_it
            content_pt
            image
          }
        }
      `, {
    name: 'getBannerData',
    options: {
      ssr: false
    }
  }),
)(HomeBanner);
